export function isCpfValid(cpf) {
  cpf = cpf.replace(/[^\d]/g, "");

  if (cpf === "") {
    return { $error: false };
  }

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return { $error: true };
  }

  let sum;
  let remainder;

  sum = 0;
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }

  remainder = (sum * 10) % 11;

  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cpf.substring(9, 10))) {
    return { $error: true };
  }

  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }

  remainder = (sum * 10) % 11;

  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cpf.substring(10, 11))) {
    return { $error: true };
  }

  return { $error: false };
}
export function cpfFormatter(value) {
  if (typeof value !== "string") {
    value = value !== null && value !== undefined ? String(value) : "";
  }
  let cleanedCpf = value.replace(/\D/g, "");

  cleanedCpf = cleanedCpf.replace(/(\d{3})(\d)/, "$1.$2");
  cleanedCpf = cleanedCpf.replace(/(\d{3})(\d)/, "$1.$2");
  cleanedCpf = cleanedCpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

  return cleanedCpf;
}
